export type Pak = {
  id: number
  pakNumber: string
  product: unknown | null
  grade: string
  gradeId: number
  kitType: string
  registrationDate: string
  expiryDate: string | null
  isMegaPak: boolean
}

export type TrainingReport = {
  type: string
  skuCode: string
  current_track_title?: string
  status?: string
  doneAt?: string | null
  [key: string]: any
}

export type Archetype = {
  id: number
  archetypeName: string
  description: string
  userArchetypes: unknown | null
  createdBy: string
  createdDate: string
}

export type CurrentUser = {
  alternateEmail: string
  archetypes?: Archetype[]
  city?: string
  contactPhoneNumber?: string | null
  country?: string
  createdBy: string
  createdDate: string
  displayName: string
  email: string
  firstName?: string
  groupMembership: string[]
  hasInactiveNetSuiteCustomer?: boolean
  hasUpdatedProfile: boolean
  id: number
  isFirstTimeUser: boolean
  isOldPWFormat: boolean
  isSSO?: boolean
  lastLoggedInAt: string
  lastModified: string
  lastName?: string
  mobilePhoneNumber?: string | null
  modifiedBy: string
  netSuiteCustomerId?: number
  region?: string
  roles: string[]
  siteName?: string
  title?: string
  userName: string
}

export enum GroupMembership {
  CSS_ADMINS = 'CSS Admins',
  TECHNOLOGY_ADMINS = 'Technology Admins',
  OPERATIONS_ADMINS = 'Operations Admins',
}
